var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Arrow-Round-Right--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Arrow Round Right Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-round-right--diagram-round-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M8.64905 1.00245c0 -0.303349 0.18273 -0.576826 0.46298 -0.692912 0.28026 -0.116085 0.60285 -0.051918 0.81735 0.16258L12.3284 2.87114c0.2929 0.29289 0.2929 0.76777 0 1.06066L9.92938 6.33082c-0.2145 0.2145 -0.53709 0.27867 -0.81735 0.16258 -0.28025 -0.11608 -0.46298 -0.38956 -0.46298 -0.69291V4.40137H7.00003c-2.09761 0 -3.79805 1.70045 -3.79805 3.79805 0 2.09758 1.70044 3.79808 3.79805 3.79808 2.0976 0 3.79807 -1.7005 3.79807 -3.79808 0 -0.55229 0.4477 -1 1 -1s1 0.44771 1 1c0 3.20218 -2.5959 5.79808 -5.79807 5.79808 -3.20218 0 -5.79805 -2.5959 -5.79805 -5.79808 0 -3.20217 2.59587 -5.79805 5.79805 -5.79805h1.64902V1.00245Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIconWhite);
export default __webpack_public_path__ + "static/media/reload-icon-white.7c6a121d0a3eadc326c97c403e8c9a8b.svg";
export { ForwardRef as ReactComponent };